import BookingData from "@/classes/BookingData"
import LiheContent from '@/model/Content/LiheContent'
import { LiheContentResponseDTO, QuoteState } from "@requests"

const buildLiheContent = (data: LiheContentResponseDTO): LiheContent => {
    const liheContent = new LiheContent(
        data.liheId,
        data.liheName,
        data.stationId,
        data.stationName,
        data.pictureLodging,
        data.countryId,
        data.countryName,
        data.regionId,
        data.regionName,
        data.criterias,
    )
    return liheContent
}

const processLihe = (bookingData: BookingData, sourceObj: QuoteState) => {
    // set data on lihe
    const startDate: string = sourceObj.startDate
    const endDate: string = sourceObj.endDate
    bookingData.lihe.setStartDate(startDate)
    bookingData.lihe.setEndDate(endDate)

    const liheContentResponse: LiheContentResponseDTO = bookingData.responses.liheContentResponse!

    // create lihe content object
    const liheContent: LiheContent = buildLiheContent(liheContentResponse)
    bookingData.lihe.setContent(liheContent)
}

export default processLihe